/// <amd-module name="VC/Common/MenuProvider" />
import { IVssContributableMenuService } from "VSS/Features/Frame/IVssContributableMenuService";
import { IVssPageContext, Services, VssService } from "VSS/Platform/Context";
import { IVssContextualMenuItem } from "VSSUI/Components/VssContextualMenu/VssContextualMenu.Props";

import { ITfsPageData, ITfsPageService } from "Tfs/Platform/Page";

import { IVCNavigationService } from "./Navigation";

class MenuProviderService extends VssService implements IVssContributableMenuService {
    public loadItems(itemsUpdated: (menuItems: IVssContextualMenuItem[], removedItems?: string[]) => void) : void {
        const pageService = this.pageContext.getService<IVCNavigationService>("IVCNavigationService");
        const pageData = pageService.getData();

        if (pageData) {

            const tfsPageService = this.pageContext.getService<ITfsPageService>("ITfsPageService");
            const tfsPageData = tfsPageService.getData();

            const projectName = (tfsPageData && tfsPageData.project) ? tfsPageData.project.name : "";
            const name = pageData.defaultRepoIsGit ? pageData.defaultGitRepoName : "$/" + projectName;
            const iconName = pageData.defaultRepoIsGit ? "git" : "tfvc-repo";
            const href = pageData.defaultRepoIsGit ? pageData.defaultGitRepoUrl : pageService.getRepositoryUrl(null);

            const menuItems: IVssContextualMenuItem[] = [{
                key: "vcRepoItem",
                className: "repo-menu-item",
                groupKey: "navigation",
                href: href,
                name: name,
                iconProps: { iconName: "", className: "bowtie-icon bowtie-" + iconName },
                rank: 50
            }];

            itemsUpdated(menuItems);
        }
    }
}    

Services.add("code-hub-group-menu-provider", { serviceFactory: MenuProviderService });
